import { useQuery } from '@tanstack/react-query'
import { onboardingApi } from '@/lib/api'

export const onboardingKeys = {
  all: ['onboarding'] as const,
  submissions: ['onboarding', 'submissions'] as const,
  submission: (id: number) => ['onboarding', 'submission', id] as const,
  barbers: (submissionId: number) => ['onboarding', 'barbers', submissionId] as const,
  services: (submissionId: number) => ['onboarding', 'services', submissionId] as const,
  features: (submissionId: number) => ['onboarding', 'features', submissionId] as const,
}

export function useOnboardingSubmissions() {
  return useQuery({
    queryKey: onboardingKeys.submissions,
    queryFn: async () => {
      const response = await onboardingApi.listSubmissions()
      return response.data
    },
  })
}

export function useOnboardingSubmission(id: number) {
  return useQuery({
    queryKey: onboardingKeys.submission(id),
    queryFn: async () => {
      const response = await onboardingApi.getSubmission(id)
      return response.data
    },
    enabled: !!id,
  })
}

export function useOnboardingBarbers(submissionId: number) {
  return useQuery({
    queryKey: onboardingKeys.barbers(submissionId),
    queryFn: async () => {
      const response = await onboardingApi.listBarbers(submissionId)
      return response.data
    },
    enabled: !!submissionId,
  })
}

export function useOnboardingServices(submissionId: number) {
  return useQuery({
    queryKey: onboardingKeys.services(submissionId),
    queryFn: async () => {
      const response = await onboardingApi.listServices(submissionId)
      return response.data
    },
    enabled: !!submissionId,
  })
}

export function useOnboardingFeatures(submissionId: number) {
  return useQuery({
    queryKey: onboardingKeys.features(submissionId),
    queryFn: async () => {
      const response = await onboardingApi.getFeatures(submissionId)
      return response.data
    },
    enabled: !!submissionId,
  })
}
